import $ from "jquery";
window.$ = window.jQuery = $;

export const allNewsFilterPagination = () => {
	(($) => {
		$(document).on("facetwp-loaded", () => {
			if (FWP.loaded) {
				$("html, body").animate(
					{
						scrollTop: $(".section-intro").offset().top,
					},
					500,
				);
			}
		});
	})(jQuery);
};

export const latestNewsFilter = () => {
	$(".filter-container .filter-group").each(function () {
		const l_btn = $(this).find(".filter-btn"),
			l_dd = $(this).find(".filter-dropdown"),
			l_cls = $(this).attr("class").split(" ")[1];

		l_btn.click((e) => {
			$(".filter-container .filter-group:not(." + l_cls + ") .filter-btn").removeClass("open");
			$(".filter-container .filter-group:not(." + l_cls + ") .filter-dropdown").removeClass("d-block");

			if (l_btn.hasClass("open")) {
				l_btn.removeClass("open");
			} else {
				l_btn.addClass("open");
			}
			if (l_dd.hasClass("d-block")) {
				l_dd.removeClass("d-block");
			} else {
				l_dd.addClass("d-block");
			}

			e.stopPropagation();
		});

		$(document).click((e) => {
			if (
				!$(e.target).is(".filter-container .filter-checkbox label") &&
				!$(e.target).is(".filter-container .filter-checkbox input")
			) {
				l_btn.removeClass("open");
				l_dd.removeClass("d-block");
			}
		});
	});

	$(".filter-mobile-btn").click((e) => {
		e.preventDefault();
		$(".filter-container").show();
	});

	$(".filter-toggle-close, .filter-done").click((e) => {
		e.preventDefault();
		$(".filter-container").hide();
	});
};

export const gamesFilter = () => {
	(($) => {
		$(document).on("facetwp-loaded", () => {
			fUtil(".page-games #facet .facetwp-type-sort select").fSelect({ showSearch: false });

			$(".blog .facetwp-pager .facetwp-page").each(function () {
				const el = $(this);

				el.click(function () {
					const dp = $(this).attr("data-page");
					$('.blog .facetwp-pager .facetwp-pager[class^="active-"]').removeClass();
					$(".blog .facetwp-pager .facetwp-pager").addClass("active-" + dp);
				});
			});
		});
	})(jQuery);
};

export const facetFilterMobile = () => {
	(($) => {
		$("#facet .filter-toggle").click((e) => {
			e.preventDefault();
			$("#facet .dropdown-group").removeClass("d-none");
			$("body").addClass("overflow-hidden");
		});

		$("#facet .filter-toggle-close, #facet .filter-done").click((e) => {
			e.preventDefault();
			$("#facet .dropdown-group").addClass("d-none");
			$("body").removeClass("overflow-hidden");
		});

		$("#facet .facetwp-facet").each(function () {
			$(this).click(() => {
				$("#facet .dropdown-group-select").removeClass("dropdown-group-padded");

				setTimeout(() => {
					if ($("#facet .dropdown-group-select").height() > $(window).height() * 0.84) {
						$("#facet .dropdown-group-select").addClass("dropdown-group-padded");
					}
				}, 10);
			});
		});
	})(jQuery);
};
